export const baseApiURL = process.env.NEXT_PUBLIC_BASE_API_URL

export const apiEndPoints = {
  addEventGlobalCalendar: 'events/create',
  addWebinarGlobalCalendar: 'webinars/create',
  getEventAndWebinar: 'global-calendar',
  globalPeopleList: 'graph/users-and-gr/list',
  globalPeopleListForWebinar: 'graph/users/list',
  getEvent: 'events/get',
  deleteEvent: 'events/delete',
  getAllWebinar: 'webinars/get',
  deleteWebinarGlobalCalendar: 'webinars/delete',
  updateEventGlobalCalendar: 'events/update',
  updateWebinarGlobalCalendar: 'webinars/update',
  globalPeopleListById: 'graph/user'
}
